export default function getArrayNumbers() {
  const array = [];
  for (let index = 0; index < 29; index += 1) {
    array.push({ name: index, id: index });
  }

  return array;
}
